// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // serverUrl: 'http://localhost:9901'
  serverUrl: 'https://dev1.otimusclinic.com.br:9812'
  // serverUrl: 'https://lak-ag.otimusclinic.com:9901'
  // serverUrl: 'https://santavisita.otimusclinic.com:9902'
};

// export const environment = {
//   production: false,
//   serverUrl: 'https://lak-ag.otimusclinic.com:9901',
//   otimusUrl: 'https://lak-ag.otimusclinic.com/otimus/rest',
//   otimusNodeUrl: 'https://lag-ag.otimusclinic.com:9797'
// };

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
